import React, { Component } from 'react';
import { bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types'
import {withI18n} from 'react-i18next';
import {Link} from 'react-router-dom';
import validator from 'validator';
import {Segment, Table, Dimmer, Loader, Icon, Modal, Header, Form} from 'semantic-ui-react';
import SegmentRibbon from '../includes/partials/SegmentRibbon';
import PageBreadCrub from '../includes/partials/PageBreadCrub';
import qs from 'qs';
import update from 'immutability-helper';
import {
    fetchPaginatedList
} from '../../actions/integration';
import {api} from '../../api';
import OrderBy from '../includes/tables/OrderBy';
import SearchBar from '../includes/tables/SearchBar';
import Pagination from '../includes/tables/Pagination';
import FilterBy from '../includes/tables/FilterBy';
import AlertComponent from '../includes/messages/alert';
import Lara from '../../lara';
import LaraPagination from '../../laraPagination';
import PartnerLogo from './components/PartnerLogo';
import PrimaryNaviButton from '../includes/buttons/PrimaryNaviButton';
import SecondaryButton from '../includes/buttons/SecondaryButton';
import ClientFormSelector from '../includes/selectors/ClientFormSelector';
import PrimaryButton from '../includes/buttons/PrimaryButton';

class BillingActivityListPage extends Component {
    constructor() {
        super();
        this.state = {
            breadcrub: [
                {isLink:false, to:null, tag: 'Integration', active: false, key: 1}
            ],
            loading: false,
            routingQuery: {

            },
            routingPath: "",
            search: "",
            fbaInvitationModal: false,
            invite: {
                client_id: "",
                to: "",
                cc: ""
            }
        }
    }
    
    componentDidUpdate(prevProps, prevState) {
        const {params, url} = this.props.match;
        if (url !== this.state.routingPath) {
            this.setRoutingInState(params, url);
        }
    }

    componentDidMount() {
        const {params, url} = this.props.match;
        this.setRoutingInState(params,url);
        this.setState({
            invite: {
                client_id: "",
                to: "",
                cc: this.props.user.email
            }
        })
    }

    setRoutingInState = ({query}, url) => {
        const q = qs.parse(query);
        //order_by
        //filter_by
        //query
        if (!_.isObject(q.filter_by)) {
            q.filter_by = {};
        }
        if (!_.isObject(q.order_by)) {
            q.order_by = {};
        }
        if (!_.isArray(q.query)) {
            q.query = [];
        }
        this.setState({
            loading: true,
            routingQuery: q,
            routingPath: url,
            search: q.search
        }, () => {
            this.fetchRecords(query)
        });
    }

    fetchRecords = () => {
        this.props.fetchPaginatedList(qs.stringify(this.state.routingQuery)).then(res => {
            this.setState({loading: false});
        }).catch(err => {
            const errors = Lara.axiosError(err, this.props.t);
            if (errors.http_code === 422) {
                this.setState({
                    errors: errors.message,
                    loading: false
                });
            } else {
                this.setState({
                    loading: false
                });
                Lara.axiosAlert(<AlertComponent 
                    support={errors.support}
                    message={errors.message}
                    reference={errors.reference}
                    t={this.props.t}
                />);
            }
            this.setState({loading: false});
        });
    }

    routeToNewQuery = (newRoutingQuery) => {
        this.props.history.push(`/integrations/${qs.stringify(newRoutingQuery)}`);
    }

    /*
     * For table header filters
    */
    onOrderByHeaderClicked = (routingOrderName, value) => {
        const newRoutingQuery = update(this.state.routingQuery, {
            order_by: {
                [routingOrderName]: {$set: value}
            }
        });
        this.routeToNewQuery(newRoutingQuery);
    }

    /*
     * For pagination
    */
    onPaginationClicked = (e, data) => {
        const {activePage} = data;
        const newRoutingQuery = update(this.state.routingQuery, {
            on_page: {$set: activePage}
        });
        this.routeToNewQuery(newRoutingQuery);
    }

    /*
     *
     */
    onFilterSelectChange = (field, value) => {
        this.setState({
            routingQuery: update(this.state.routingQuery, {
                filter_by: {
                    [field]: {$set: value.join()}
                }
            })
        }, () => {
            this.routeToNewQuery(this.state.routingQuery);
        });
    }

    //New Sep 12, 2019 - add pagination per page selector
    onPerPageChanged = (newPerPage) => {
        const query = update(this.state.routingQuery, {per_page: {$set: newPerPage}});
        this.routeToNewQuery(query);
    }

    /*
     * For Search bar: onSearchEnterKeyPressed onSearchChange onPredefinedRouteSelected (optional)
     */
    onSearchEnterKeyPressed = (e) => {
        if (e.key === 'Enter') {
            const defaultQuery = LaraPagination.integrations(true);
            defaultQuery.search = this.state.search;
            this.routeToNewQuery(defaultQuery);
        }
    }

    getClientName = (clientId) => {
        const {clients} = this.props;
        const clientIndex = _.findIndex(clients, c => {
            return parseInt(c.id, 10) === parseInt(clientId, 10);
        })
        if (clientIndex > -1) {
            return clients[clientIndex].company
        }
        return "NA"
    }

    sendInviteEmail = () => {
        const {invite} = this.state;
        if (!invite.client_id) {
            return null;
        }
        if (!validator.isEmail(invite.to)) {
            return null;
        }
        if (!validator.isEmail(invite.cc)) {
            return null;
        }

        this.setState({
            loading: true
        });
        api.integrations.fbaInvite(invite).then(res => {
            this.setState({
                fbaInvitationModal: false,
                loading: false,
                invite: {
                    client_id: "",
                    to: "",
                    cc: this.props.user.email
                }
            })
            Lara.alertSuccess("Request sent. Please check your email");
        }).catch(err => {
            this.setState({
                loading: false
            })
            Lara.alertError("Cannot send email. Please try again later");
        })
    }

    render() {
        const {routingQuery, search} = this.state;
        const {t, list, fba} = this.props;
        const {on_page, per_page, total} = list;
        const orderBy = _.isObject(routingQuery.order_by) ? routingQuery.order_by : {};
        const filterBy = _.isObject(routingQuery.filter_by) ? routingQuery.filter_by : {
            type: "",
            is_active: ""
        };
        return (
            <div>
                {/* Breadcrub Row */}
                <div className="row">
                    <div className="col-md-12 lara-breadcrub">
                        <PageBreadCrub lists={this.state.breadcrub} t={t}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <Segment>
                            <SegmentRibbon label={`${t('Integration')} ${t('Search')}`} Buttons={
                                () => {return (<React.Fragment>
                                    <PrimaryNaviButton
                                        link={'/integrations/new/action/edit'}
                                        size='mini'
                                        float='right'
                                        loading={false}
                                        label={t('Create')}
                                    />
                                    {fba ? <SecondaryButton
                                        size='mini'
                                        float='right'
                                        label={t('Invite FBA')}
                                        onClick={() => {
                                            this.setState({
                                                fbaInvitationModal: true
                                            })
                                        }}
                                        loading={this.state.loading}
                                    /> : null}
                                </React.Fragment>)}
                            }/>
                            <SearchBar
                                placeholder='Search by client company...'
                                onSearchEnterKeyPressed={(e) => {this.onSearchEnterKeyPressed(e)}}
                                search={search}
                                onSearchChange={(search) => {this.setState({search})}}
                                onPredefinedRouteSelected={() => null}
                                options={[]}
                                havePreferenceSelect={false}
                                hasPerPageSelector={routingQuery.per_page}
                                onPerPageSelcted={(perPage) => {
                                    this.onPerPageChanged(perPage);
                                }}
                            />

                            <div className="row">
                                <FilterBy
                                    t={t}
                                    label={t('Partner')}
                                    options={[
                                        {value: '4', text: t('Shopify')},
                                        {value: '5', text: t('WooCommerce')},
                                        {value: '6', text: t('TradeGecko')},
                                        {value: '8', text: t('ShipStation Order')},
                                        {value: '10', text: t('Magento V2')},
                                        {value: '11', text: t('US FBA')},
                                        {value: '14', text: t('3rd Party ShipStation')},
                                        {value: '15', text: t('Zalora')}
                                    ]}
                                    name="type"
                                    currentValueString={filterBy.type ? filterBy.type : ""}
                                    onFilterSelectChange={(name, value) => {this.onFilterSelectChange(name, value)}}
                                    fullWidth={true}
                                />
                            </div>
                        </Segment>
                        
                        <Segment>
                            <Dimmer inverted active={this.state.loading}>
                                <Loader />
                            </Dimmer>
                            <SegmentRibbon label={`${t('Integration')} ${t('List')}`}/>
                            <div className="row lara-row-margin">
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <Table
                                        compact
                                        basic
                                        padded={false}
                                    >
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell>
                                                    <OrderBy
                                                        t={t}
                                                        name='Name'
                                                        routingOrderName='name'
                                                        currentOrder={orderBy.name}
                                                        onOrderClick={(routingOrderName, value) => {this.onOrderByHeaderClicked(routingOrderName, value)}}
                                                    />
                                                </Table.HeaderCell>
                                                <Table.HeaderCell>
                                                    {t('Partner')}
                                                </Table.HeaderCell>
                                                <Table.HeaderCell>
                                                    {t("Client")}
                                                </Table.HeaderCell>
                                                <Table.HeaderCell>
                                                    {t('Verified')}
                                                </Table.HeaderCell>
                                                <Table.HeaderCell>
                                                    <OrderBy
                                                        t={t}
                                                        name='CreatedAt'
                                                        routingOrderName='created_at'
                                                        currentOrder={orderBy.created_at}
                                                        onOrderClick={(routingOrderName, value) => {this.onOrderByHeaderClicked(routingOrderName, value)}}
                                                    />
                                                </Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>

                                        <Table.Body>
                                            {list.records.map((i,index) => {
                                                return (<Table.Row key={i.id}>
                                                    <Table.Cell>
                                                        <Link to={`/integrations/${i.id}/action/view`}>
                                                            {i.name}
                                                        </Link>
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        <PartnerLogo type={i.type} />
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {this.getClientName(i.client_id)}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {i.verified ? <Icon name="check" color='green' /> : <Icon name="times" />}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {moment(i.created_at).format('MMM DD, Y').toString()}
                                                    </Table.Cell>
                                                </Table.Row>)
                                            })}
                                        </Table.Body>
                                    </Table>
                                </div>
                            </div>
                        
                            <div className="row lara-row-margin">
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    <Pagination 
                                        activePage={on_page}
                                        totalRecords={total}
                                        perPage={per_page}
                                        onPageChange={(e, data) => {
                                            this.onPaginationClicked(e,data);
                                        }}
                                    />
                                </div>
                            </div>
                        </Segment>
                    </div>
                    <Modal
                        closeOnDimmerClick={false}
                        closeIcon
                        size='mini'
                        onClose={() => {
                            this.setState({fbaInvitationModal: false})
                        }}
                        closeOnEscape={true} open={this.state.fbaInvitationModal}>
                        <Header icon='pencil' content="FBA Invitation" />
                        <Modal.Content>
                            <Form size='mini'>
                                <ClientFormSelector
                                    clients={this.props.clients}
                                    value={this.state.invite.client_id}
                                    onSelected={(value) => {
                                        this.setState({
                                            invite: update(this.state.invite, {
                                                client_id: {$set: value}
                                            })
                                        })
                                    }}
                                    size='mini'
                                    required={true}
                                    label="Client"
                                />
                                <Form.Input
                                    label="Email To"
                                    type='email'
                                    required={true}
                                    value={this.state.invite.to}
                                    onChange={(e, {value}) => {
                                        this.setState({
                                            invite: update(this.state.invite, {
                                                to: {$set: value}
                                            })
                                        })
                                    }}
                                />
                                <Form.Input
                                    label="Email CC"
                                    type='email'
                                    required={true}
                                    value={this.state.invite.cc}
                                    onChange={(e, {value}) => {
                                        this.setState({
                                            invite: update(this.state.invite, {
                                                cc: {$set: value}
                                            })
                                        })
                                    }}
                                />
                            </Form>
                            <div className="row lara-row-margin">
                                <div className="col-md-12">
                                <PrimaryButton
                                    size='mini'
                                    float='right'
                                    label={t('Send Invite')}
                                    onClick={() => {
                                        this.sendInviteEmail()
                                    }}
                                    loading={this.state.loading}
                                />
                                </div>
                            </div>
                        </Modal.Content>
                    </Modal>
                </div>
            </div>
        )
    }
}

BillingActivityListPage.propTypes = {
    t: PropTypes.func.isRequired,
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.shape({
        params: PropTypes.object.isRequired,
        path: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired
    }),
    fetchPaginatedList: PropTypes.func.isRequired,
    list: PropTypes.object.isRequired,
    clients: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        list: state.apiList.list,
        clients: state.system.clients,
        fba: state.system.do_fba,
        user: state.system.user
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchPaginatedList
    }, dispatch)
}

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(BillingActivityListPage));